import { render, staticRenderFns } from "./orders-box-mobile.vue?vue&type=template&id=73ee4ce6&scoped=true&"
import script from "./orders-box-mobile.vue?vue&type=script&lang=js&"
export * from "./orders-box-mobile.vue?vue&type=script&lang=js&"
import style0 from "./orders-box-mobile.vue?vue&type=style&index=0&id=73ee4ce6&prod&lang=css&"
import style1 from "./orders-box-mobile.vue?vue&type=style&index=1&id=73ee4ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ee4ce6",
  null
  
)

export default component.exports